/**
 * CandyDuo - Sachet en attente (partagé sur tout le site)
 * ---------------------------------------------------------
 * Stocke, dans le navigateur du client (localStorage), un sachet de
 * bonbons en vrac "en attente" : il suit le client d'une page à
 * l'autre, indépendamment du vrai panier Shopify, et n'est ajouté au
 * panier qu'au clic sur "Valider mon sachet".
 *
 * Utilisé par :
 *  - sections/candy-bundle-builder.liquid ("Compose ton sachet")
 *  - snippets/candyduo-sachet-bar.liquid (barre flottante globale)
 *  - sections/candyduo-suggested-products.liquid ("Produits phares")
 */
(function (window) {
  var STORAGE_KEY = 'candyduo_sachet_v1';
  var UNIT_GRAMS = 100;

  // Paliers de prix (doivent rester cohérents avec les réglages du
  // compositeur et les remises automatiques Shopify "Palier 500g/1kg").
  var TIERS = {
    tier2Grams: 500,
    tier2Cents: 170,
    tier3Grams: 1000,
    tier3Cents: 160,
    baseCents: 180,
  };

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* localStorage indisponible (navigation privée, quota...) : on ignore */
    }
    try {
      window.dispatchEvent(new CustomEvent('candyduo:sachet:updated', { detail: { items: items } }));
    } catch (e) {
      /* ignore */
    }
  }

  function findIndex(items, variantId) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].variantId === variantId) return i;
    }
    return -1;
  }

  function setQty(variantId, qty, meta) {
    var items = read();
    var idx = findIndex(items, variantId);
    var safeQty = Math.max(0, Math.min(20, qty | 0));
    if (safeQty <= 0) {
      if (idx !== -1) items.splice(idx, 1);
    } else if (idx !== -1) {
      items[idx].qty = safeQty;
      if (meta) {
        for (var k in meta) {
          if (Object.prototype.hasOwnProperty.call(meta, k)) items[idx][k] = meta[k];
        }
      }
    } else {
      var entry = { variantId: variantId, qty: safeQty };
      if (meta) {
        for (var k2 in meta) {
          if (Object.prototype.hasOwnProperty.call(meta, k2)) entry[k2] = meta[k2];
        }
      }
      items.push(entry);
    }
    write(items);
    return items;
  }

  function increment(variantId, delta, meta) {
    var items = read();
    var idx = findIndex(items, variantId);
    var current = idx !== -1 ? items[idx].qty : 0;
    return setQty(variantId, current + delta, meta);
  }

  function getQty(variantId) {
    var items = read();
    var idx = findIndex(items, variantId);
    return idx !== -1 ? items[idx].qty : 0;
  }

  function clear() {
    write([]);
  }

  function totals(items) {
    items = items || read();
    var totalQty = 0;
    var rawCents = 0;
    for (var i = 0; i < items.length; i++) {
      var qty = items[i].qty || 0;
      totalQty += qty;
      rawCents += qty * (items[i].priceCents || TIERS.baseCents);
    }
    var totalGrams = totalQty * UNIT_GRAMS;
    var tier = 1;
    var unitCents = TIERS.baseCents;
    if (totalGrams >= TIERS.tier3Grams) {
      tier = 3;
      unitCents = TIERS.tier3Cents;
    } else if (totalGrams >= TIERS.tier2Grams) {
      tier = 2;
      unitCents = TIERS.tier2Cents;
    }
    var totalCents = totalQty * unitCents;
    return { totalQty: totalQty, totalGrams: totalGrams, totalCents: totalCents, tier: tier, rawCents: rawCents };
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function nextSachetLabel(cart) {
    var count = 1;
    try {
      var items = (cart && cart.items) || [];
      var seen = {};
      items.forEach(function (it) {
        var props = it.properties || {};
        var label = props['Sachet'];
        if (label && !seen[label]) { seen[label] = true; count++; }
      });
    } catch (e) {}
    return 'Sachet ' + count;
  }

  function notifyCartUpdate(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'candyduo-sachet', data: {} },
      }));
    } catch (e) {}
  }

  function checkout(onError) {
    var items = read();
    if (items.length === 0) return Promise.resolve(false);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (currentCart) {
        var label = nextSachetLabel(currentCart);
        var payload = items.map(function (it) {
          return { id: it.variantId, quantity: it.qty, properties: { Sachet: label } };
        });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: payload }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              var msg = (result.data && result.data.description) || 'Une erreur est survenue, réessaie.';
              if (onError) onError(msg);
              return false;
            }
            clear();
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (res) { return res.json(); })
              .then(function (freshCart) {
                notifyCartUpdate(freshCart);
                return true;
              })
              .catch(function () {
                notifyCartUpdate(result.data);
                return true;
              });
          });
      })
      .catch(function () {
        if (onError) onError('Une erreur est survenue, réessaie.');
        return false;
      });
  }

  window.CandyduoSachet = {
    STORAGE_KEY: STORAGE_KEY,
    UNIT_GRAMS: UNIT_GRAMS,
    TIERS: TIERS,
    read: read,
    write: write,
    setQty: setQty,
    increment: increment,
    getQty: getQty,
    clear: clear,
    totals: totals,
    formatMoney: formatMoney,
    checkout: checkout,
  };
})(window);
